//React
import React, { useEffect } from "react";
//Components
import { FlexBox, Image, Screen } from "components";
//Utils
import { ChangeHistory, getURLParameter, nameFunctions } from "utils";
//Styles
import "./styles.scss";
//Assets
import WhatsappLogin from "assets/demo/whatsapp-button.svg";
import GoogleLogin from "assets/demo/google-button.svg";
import FacebookLogin from "assets/demo/facebook-button.svg";
import PoweredByOTPless from "assets/PoweredByOTPless.png";
import { useState } from "react";
import { globalConstant } from "../../constants";
import ROUTE_PATH from "Routes/paths";
const Demo = () => {
  //State
  const [domain, setDomain] = useState("otpless.com");
  const [orgData, setOrgData]: any = useState({});

  //onLoad
  useEffect(() => {
    if (getURLParameter(globalConstant.URL_PARAMETER.DOMAIN)) {
      const tempDomain = getURLParameter(globalConstant.URL_PARAMETER.DOMAIN);
      setDomain(tempDomain.split(".")[0]);
      // window
      //   .fetch(
      //     `https://api.apollo.io/v1/organizations/enrich?api_key=9pGJjofPgrOx9onAA9a2CA&domain=${tempDomain}`
      //   )
      //   .then((res) => res.json())
      //   .then((data) => {
      //     setOrgData({ ...data.organization });
      //   });
    }
  }, []);

  //Actions
  const whatsAppAction = () => {
    window.open(`https://${domain}.authlink.me`, "_self");
  };

  //Return UI
  return (
    <Screen className="demo-screen">
      {/* <iframe src="https://mihit.authlink.me/getdata.html"></iframe> */}
      <FlexBox flexColumn justifyCenter alignCenter className="org-details">
        {/* {orgData?.logo_url ? (
          <Image src={orgData?.logo_url} className="w-20 br-100 drop-shadow" />
        ) : (
          <FlexBox
            justifyCenter
            alignCenter
            className="icon-name fs-22 font-heavy"
          >
            {nameFunctions.getIconName(orgData?.name ?? "OTPless")}
          </FlexBox>
        )} */}
        <p className="fs-20 font-heavy mr-t-10">
          {getURLParameter(globalConstant.URL_PARAMETER.DOMAIN) ?? "OTPless"}
        </p>
      </FlexBox>
      <FlexBox flexColumn justifyCenter alignCenter className="login-buttons">
        <Image
          src={WhatsappLogin}
          className="clicking-animation"
          onClick={() => {
            whatsAppAction();
          }}
        />
        <Image src={GoogleLogin} className="clicking-animation disabled" />
        <Image src={FacebookLogin} className="clicking-animation disabled" />
      </FlexBox>
      <FlexBox
        flexColumn
        justifyEnd
        alignCenter
        className="footer-line pd-b-20"
      >
        <Image
          src={PoweredByOTPless}
          className="w-40 clicking-animation"
          onClick={() => {
            ChangeHistory("push", ROUTE_PATH.SAMPLES.LANDING);
          }}
        />
      </FlexBox>
    </Screen>
  );
};

export default Demo;
